import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ShopProducts from "../Components/ShopProducts";

function Shop() {
    const [categories, setCategories] = useState([]);

    // 📌 Fetch Categories from API
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get("https://api.irfanelectricals.com/api/categories");
                console.log("Fetched Categories:", response.data.categories); // ✅ Debug
                setCategories(response.data.categories);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);

    return (
        <>
            <Navbar />
            <section id="center" className="center_o pt-5 pb-5 bg_light">
                <div className="container-xl">
                    <div className="row center_o1 text-center">
                        <div className="col-md-12">
                            <h1 className="text-uppercase">Product</h1>
                            <h6 className="d-inline-block mb-0 col_yell">
                                <a href="#">Home</a> <span className="mx-2 text-muted">/</span> Product
                            </h6>
                        </div>
                    </div>
                </div>
            </section>

            {/* Categories Section */}
            <section id="popular" className="p_3">
                <div className="container-xl">
                    <div className="row popular_1 mb-3">
                        <div className="col-md-12">
                            <h1 className="mb-0">Product Categories</h1>
                        </div>
                    </div>
                    <div className="row popular_2">
                        {categories.length > 0 ? (
                            categories.map((category) => (
                                <div key={category.id} className="col-md-2 col-6">
                                    <div className="popular_2i">
                                        <div className="grid clearfix">
                                            <figure className="effect-jazz mb-0">
                                                <a href={`detail.html?category=${category.id}`}>
                                                    <img 
                                                        src={category.image} 
                                                        className="w-100" 
                                                        alt={category.name} 
                                                        onError={(e) => e.target.src = "https://via.placeholder.com/150"} 
                                                    />
                                                </a>
                                            </figure>
                                        </div>
                                        <h6 className="mb-0 mt-3 fw-normal">
                                            <a href={`detail.html?category=${category.id}`}>{category.name}</a>
                                        </h6>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-12 text-center">
                                <p>No categories found</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <ShopProducts />
            <Footer />
        </>
    );
}

export default Shop;
